const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopyDomain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 5.16666C8.83301 4.23325 8.83301 3.76654 9.01466 3.41002C9.17445 3.09641 9.42942 2.84144 9.74302 2.68166C10.0995 2.5 10.5663 2.5 11.4997 2.5H13.833L17.1663 5.83333V10.6667C17.1663 11.6001 17.1663 12.0668 16.9847 12.4233C16.8249 12.7369 16.5699 12.9919 16.2563 13.1517C15.8998 13.3333 15.4331 13.3333 14.4997 13.3333H11.4997C10.5663 13.3333 10.0995 13.3333 9.74302 13.1517C9.42942 12.9919 9.17445 12.7369 9.01466 12.4233C8.83301 12.0668 8.83301 11.6001 8.83301 10.6667V5.16666Z",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1663 13.3346V14.8346C12.1663 15.7681 12.1663 16.2348 11.9847 16.5913C11.8249 16.9049 11.5699 17.1599 11.2563 17.3196C10.8998 17.5013 10.4331 17.5013 9.49967 17.5013H6.49968C5.56625 17.5013 5.09954 17.5013 4.74302 17.3196C4.42942 17.1599 4.17445 16.9049 4.01466 16.5913C3.83301 16.2348 3.83301 15.7681 3.83301 14.8346V9.33463C3.83301 8.40121 3.83301 7.9345 4.01466 7.57798C4.17445 7.26438 4.42942 7.00941 4.74302 6.84962C5.09954 6.66797 5.56625 6.66797 6.49967 6.66797H8.83301",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2.5V5.33333C13 5.80004 13 6.0334 13.0908 6.21166C13.1707 6.36846 13.2982 6.49594 13.455 6.57584C13.6333 6.66667 13.8666 6.66667 14.3333 6.66667H17.1667",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyDomain);
export default __webpack_public_path__ + "static/media/icon_copy_domain.62c300932ec055233d96b3412c1ce2dc.svg";
export { ForwardRef as ReactComponent };